exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-19f24232] {\n  min-height: 100px;\n}\n.has-error[data-v-19f24232] {\n  border-bottom-width: 2px;\n  border-bottom-color: #e81212;\n}\ninput[data-v-19f24232]::-webkit-input-placeholder,\ntextarea[data-v-19f24232]::-webkit-input-placeholder {\n  color: #757575;\n}\ninput[data-v-19f24232]::-moz-placeholder,\ntextarea[data-v-19f24232]::-moz-placeholder {\n  color: #757575;\n}\ninput[data-v-19f24232]::-ms-input-placeholder,\ntextarea[data-v-19f24232]::-ms-input-placeholder {\n  color: #757575;\n}\ninput[data-v-19f24232]::placeholder,\ntextarea[data-v-19f24232]::placeholder {\n  color: #757575;\n}\n", ""]);

// exports
